import { render, staticRenderFns } from "./new_latest.html?vue&type=template&id=8563ea36&"
import script from "./NewLatest.vue?vue&type=script&lang=js&"
export * from "./NewLatest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports